import { render, staticRenderFns } from "./MobileAppReleasesList.vue?vue&type=template&id=1cdda5ba"
import script from "./MobileAppReleasesList.vue?vue&type=script&lang=ts"
export * from "./MobileAppReleasesList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports